import { body } from "../elements";

export function useSlideBanner() {
  function SlideBanner(sb, timing) {
    if (!(sb instanceof Element)) {
      return;
    }

    const slides = sb.querySelectorAll(".slider-banner__slide");
    const dots = sb.querySelectorAll(".slider-banner__slide-dots a");
    const wrapper = sb.querySelector(".slider-banner__wrap");
    const nextBtn = sb.querySelector(".slider-banner__next");
    const prevBtn = sb.querySelector(".slider-banner__previous");
    let currentSlide = sb.querySelector(".active");
    let nextSlide = currentSlide.nextElementSibling || slides[0];
    let prevSlide =
      currentSlide.previousElementSibling || slides[slides.length - 1];

    function setHeight() {
      wrapper.removeAttribute("style");
      let height = 0;
      slides.forEach((slide) => {
        const slideHeight = slide.offsetHeight;
        if (slideHeight > height) {
          height = slideHeight;
        }
      });
      wrapper.setAttribute("style", `--height: ${height}px`);
    }

    function applyClasses() {
      currentSlide && currentSlide.classList.add("active");
      nextSlide && nextSlide.classList.add("off-right");
      prevSlide && prevSlide.classList.add("off-left");
    }

    function setTabAble(slide, activate) {
      const links = slide.querySelectorAll("a");

      if (activate) {
        links.forEach((link) => link.setAttribute("tabindex", 0));
      } else {
        links.forEach((link) => link.setAttribute("tabindex", -1));
      }
    }

    function move(direction) {
      const classesToRemove = ["off-left", "active", "off-right"];

      [prevSlide, currentSlide, nextSlide].forEach(
        (item) => item && item.classList.remove(...classesToRemove)
      );
      if (direction === "back") {
        [prevSlide, currentSlide, nextSlide] = [
          prevSlide.previousElementSibling || slides[slides.length - 1],
          prevSlide,
          currentSlide,
        ];
        let newActiveDot;
        dots.forEach((dot, i) => {
          if (dot.classList.contains("active")) {
            dot.classList.remove("active");
            newActiveDot = dots[i - 1] || dots[dots.length - 1];
          }
        });
        newActiveDot.classList.add("active");
      } else {
        [prevSlide, currentSlide, nextSlide] = [
          currentSlide,
          nextSlide,
          nextSlide.nextElementSibling || slides[0],
        ];
        let newActiveDot;
        dots.forEach((dot, i) => {
          if (dot.classList.contains("active")) {
            dot.classList.remove("active");
            newActiveDot = dots[i + 1] || dots[0];
          }
        });
        newActiveDot.classList.add("active");
      }
      applyClasses();
      setTabAble(currentSlide, true);
      setTabAble(nextSlide, false);
      setTabAble(prevSlide, false);
    }

    dots.forEach((dot) =>
      dot.addEventListener("click", (e) => {
        e.preventDefault();
        const targetRef = e.currentTarget.getAttribute("href");
        const target = sb.querySelector(targetRef);
        currentSlide = target;
        nextSlide = currentSlide.nextElementSibling || slides[0];
        prevSlide =
          currentSlide.previousElementSibling || slides[slides.length - 1];

        const classesToRemove = ["off-left", "active", "off-right"];
        slides.forEach(
          (item) => item && item.classList.remove(...classesToRemove)
        );

        applyClasses();
        setTabAble(currentSlide, true);
        setTabAble(nextSlide, false);
        setTabAble(prevSlide, false);

        dots.forEach((dot) => {
          dot.classList.remove("active");
        });
        dot.classList.add("active");
      })
    );

    nextBtn.addEventListener("click", () => {
      move();
    });

    prevBtn.addEventListener("click", () => {
      move("back");
    });

    setHeight();
    applyClasses();
    setTabAble(currentSlide, true);
    setTabAble(nextSlide, false);
    setTabAble(prevSlide, false);

    const sliderBannerResizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setHeight();
      }
    });
    sliderBannerResizeObserver.observe(body);
  }

  const slideBanners = document.querySelectorAll(".slider-banner");

  slideBanners.forEach((slideBanner) => {
    const timing = parseInt(slideBanner.dataset.timing);
    SlideBanner(slideBanner, timing);
  });
}
